// CompletionButton.tsx — marks a step complete with a brief settle, then advances.
// Reused by every step type (video / article / reflection).
import React from 'react';
import { Btn } from './ui';
import { Icon } from './icons';

export function CompletionButton({
  done,
  onComplete,
  onDone,
  label,
  doneLabel = 'Done',
  variant = 'primary',
  full,
}: {
  done?: boolean;
  onComplete: () => void;
  /** Pressed again when already complete (e.g. revisiting from the Journey) →
   *  close the lesson. */
  onDone?: () => void;
  label: string;
  doneLabel?: string;
  variant?: 'primary' | 'soft' | 'amber';
  full?: boolean;
}) {
  const [justDone, setJustDone] = React.useState(false);
  const isDone = done || justDone;

  const handle = () => {
    if (isDone) {
      onDone?.();
      return;
    }
    setJustDone(true);
    // small settle so the checkmark registers before the screen advances
    window.setTimeout(onComplete, 480);
  };

  return (
    <Btn
      variant={variant}
      full={full}
      size="lg"
      onClick={handle}
      ariaLabel={isDone ? doneLabel : label}
      leading={isDone ? <Icon name="check" size={18} sw={2} /> : undefined}
    >
      {isDone ? doneLabel : label}
    </Btn>
  );
}
